import { useMutation, useQueryClient } from '@tanstack/react-query';
import { snoozeFollowupTask } from '../api/tasks';
import { notification } from 'antd';

export function useSnoozeFollowupTask(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      taskId,
      newDueDate,
      reason,
    }: {
      taskId: string;
      newDueDate: string;
      reason: string;
    }) => snoozeFollowupTask(taskId, newDueDate, reason),
    onSuccess: async () => {
      notification.success({ message: 'Follow-up snoozed successfully' });
      await queryClient.invalidateQueries({ queryKey: ['taskItems'] });
      await queryClient.invalidateQueries({ queryKey: ['taskItem'] });
      await queryClient.invalidateQueries({ queryKey: ['task-dashboard'] });
      await queryClient.invalidateQueries({ queryKey: ['contacts'] });
      await queryClient.invalidateQueries({ queryKey: ['contactKundali'] });
      onSuccess?.();
    },
    onError: () => {
      notification.error({ message: 'Failed to snooze follow-up' });
    },
  });
}
